var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-snackbar',{attrs:{"value":_vm.display,"color":_vm.level},on:{"input":_vm.setDisplay}},[_c('v-icon',[_vm._v(_vm._s(_vm.symbol))]),_c('span',{staticClass:"px-2"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }